<template>
    <div class="filter-panel w-full mt-2">
        <div class="flex"
        :class="{'mb-6' : !filterOpen && !activeFilters.length}"
        
        >
            <button class="filter-toggle flex items-center text-gray-500 hover:text-gray-700 cursor-pointer focus:outline-none"
                @click="filterOpen = !filterOpen"
                v-if="!filterOpen"
            >
                <font-awesome-icon
                    :icon="['fas', 'sliders-h']"
                ></font-awesome-icon>
                <span class="ml-2 text-gray-600 hover:text-gray-800 text-15px font-semibold">Add Filter</span>
            </button>
            <div class="relative border border-gray-200 rounded-lg mb-6 flex mt-2" style="min-width: 500px;" v-if="filterOpen">
                <div class="absolute top-0 left-5  bg-white px-2" style="transform: translateY(-50%);">
                    <span class="text-sm text-gray-600">
                        <template v-if="editing">
                            Edit Filter
                        </template>
                        <template v-else>
                            Add new Filter
                        </template>
                    </span>
                </div>
                <span class="bg-red-400 text-gray-100 rounded-full p-1 ml-1 hover:bg-red-500 hover:text-gray-100 cursor-pointer h-6 w-6 flex items-center justify-center transition-colors duration-300 ease-in-out absolute top-0 right-0"
                    style="transform: translateX(10px) translateY(-10px);"
                    @click="filterOpen = false;">
                    <font-awesome-icon  :icon="['fas', 'xmark']"
                    ></font-awesome-icon>
                </span>

                <div class="p-4">
                    <div class="flex items-center py-4 px-2 space-x-4 flex-wrap gap-y-4"
                        :class="{'' : filterOpen}">
                            <template v-if="filterOpen">
                                <multiselect
                                    class="bg-white w-64"
                                    v-if="baseFilters"
                                    :options="baseFilters"
                                    v-model="selectedFilter"
                                    :allow-empty="false"
                                    placeholder="Select a filter"
                                    label="label"
                                    track-by="value"
                                    :searchable="false"
                                    select-label=""
                                    deselect-label=""
                                />

                                <template v-if="selectedFilter">
                                    <template v-if="selectedFilter.type === 'select'">
                                        <multiselect
                                            class="bg-white w-64"
                                            :options="selectedFilter.options"
                                            v-model="selectedFilterOption"
                                            :allow-empty="false"
                                            placeholder="Select a value"
                                            label="label"
                                            track-by="value"
                                            :searchable="false"
                                            select-label=""
                                            deselect-label=""
                                        />
                                    </template>
                                    <template v-else-if="selectedFilter.type === 'date'">
                                        <div class="flex items-center">
                                            <maz-picker
                                                id="date-picker"
                                                class="w-full relative"
                                                v-model="selectedDate"
                                                :required="true"
                                                format="YYYY-MM-DD"
                                                display-format="MMM D, YYYY"
                                            />
                                        </div>
                                    </template>
                                    <template v-else-if="selectedFilter.type === 'contact'">
                                        <contact-select
                                            v-model="selectedContact"
                                            class="w-64 bg-white"
                                        />
                                    </template>
                                    <template v-else-if="selectedFilter.type === 'list'">
                                        <group-select
                                            v-model="selectedGroup"
                                            class="w-64 bg-white"
                                        />
                                    </template>
                                    
                                    <button class="text-14px pr-4" @click="applyFilter">Apply Filter</button>
                                </template>
                            </template>
                            
                    </div>        
                </div>
            </div>
            
        </div>
        <div class="relative border border-gray-200 rounded-lg mb-2 w-full flex"
        :class="{'mt-0' : filterOpen, 'mt-6' : !filterOpen}"
        v-if="activeFilters.length > 0"
        >
            <div class="absolute top-0 left-5  bg-white px-2" style="transform: translateY(-50%);">
                <span class="text-sm text-gray-600">Active Filters</span>
            </div>
            <div class="p-4 flex">
                <active-filter-label
                    v-for="(filter, index) in activeFilters"
                    :filter="filter"
                    :key="index"
                    @remove="activeFilters.splice(index, 1)"
                    @edit="editFilter(filter, index)"
                >
                </active-filter-label>        
            </div>
        </div>
        
    </div>
</template>


<script>
import axios from 'axios';
import {mapWritableState, mapActions} from 'pinia';
import { useGeneralTableStore } from '@/Stores/general_table';
import moment from 'moment';
import ContactSelect from '@/components/ContactSelect.vue';
import groupSelect from '@/components/GroupSelect.vue';
import activeFilterLabel from './activeFilterLabel.vue';
import jetInput from '@/Jetstream/Input.vue';
import _ from 'lodash';

export default {
    components: {
        jetInput, activeFilterLabel, ContactSelect, groupSelect
    },
    data: () => ({
        editing: false,
        editingIndex: null,
        selectedFilter: null,
        selectedFilterOption: null,
        selectedDate: null,
        selectedContact: null,
        selectedGroup: null,
        currentDate: null,
    }),
    mounted() {
        this.selectedDateTo = new Date();
        //from can default to a week ago
        this.selectedDate = new Date();
        this.storeApplyFilterByValue = this.applyFilterByValue;
        this.currentDate = new Date().toISOString().split('T')[0];
    },
    computed: {
        ...mapWritableState(useGeneralTableStore, [
            'availableFilters', 'activeFilters', 'filterOpen'
        ]),
        ...mapWritableState(useGeneralTableStore, {
            storeApplyFilterByValue: 'applyFilterByValue'
        }),
        baseFilters() {
            return this.availableFilters;
        },
        filterDisplayLabel() {
            if (!this.selectedFilter) return null;
            
            if (this.selectedFilter.type == "select" && this.selectedFilterOption) {
                return this.selectedFilter.label + ": " + this.selectedFilterOption.label;
            }

            if (this.selectedFilter.type == "date" && this.selectedDate) {
                return this.selectedFilter.label + ": " + moment(this.selectedDate).format('MM-DD-YYYY');
            }

            if (this.selectedFilter.type == "contact" && this.contactOptions.length > 0) {
                return this.selectedFilter.label + ": " + this.contactOptions.map(c => c.label).join(", ");
            }

            if (this.selectedFilter.type == "list" && this.selectedGroup) {
                return this.selectedFilter.label + ": " + this.selectedGroup.title;
            }

            return null;
        },
        contactOptions() {
            if (!Array.isArray(this.selectedContact)) {
                return [];
            }
            return this.selectedContact.map(c => {
                const contact = {
                    value: c.id,
                }

                if (c.first_name || c.last_name) {
                    contact.label = c.first_name + " " + c.last_name;
                } else {
                    contact.label = c.phone_number;
                }

                return contact;
            });
        }
    },
    methods: {
        ...mapActions(useGeneralTableStore, [
            'fetchData', 'clearData',
        ]),
        editFilter(filter, index) {
            this.editing = true;
            this.editingIndex = index;
            this.filterOpen = true;
            this.selectedFilter = filter.filter;
            if (filter.type == "select") {
                let option = filter.filter.options.find(o => o.value == filter.value);
                if (!option) return;
                this.selectedFilterOption = option;
            } else if (filter.type == "date") {
                //val is formated in YYYY-MM-DD
                this.selectedDate = new Date(filter.value);
            } else if (filter.type == "contact") {
                /*
               //in this case, the value could be an array, OR CSV
               //but the result is an array of contact IDs
               const contacts = await axios.get(route('api.find.contacts'), {
                   params: {
                       ids: val
                   }
                });
                this.selectedContact = contacts.data.data;
                */
            } else if (filter.type == "list") {
                /*
                const group = await axios.get(route('api.groups.view.json.byid', {
                    id: val
                }));
                this.selectedGroup = group.data;
                */
            }


        },
        async applyFilterByValue(name, val) {
            //first, look through available filters and match by name
            let filter = this.availableFilters.find(f => f.value == name);
            if (!filter) return;
            //found filter,
            this.selectedFilter = filter;
            //we may have to modify the value depending on the type of filter
            if (filter.type == "select") {
                let option = filter.options.find(o => o.value == val);
                if (!option) return;
                this.selectedFilterOption = option;
            } else if (filter.type == "date") {
                //val is formated in YYYY-MM-DD
                this.selectedDate = new Date(val);
            } else if (filter.type == "contact") {
               //in this case, the value could be an array, OR CSV
               //but the result is an array of contact IDs
               const contacts = await axios.get(route('api.find.contacts'), {
                   params: {
                       ids: val
                   }
                });
                this.selectedContact = contacts.data.data;
            } else if (filter.type == "list") {
                const group = await axios.get(route('api.groups.view.json.byid', {
                    id: val
                }));
                this.selectedGroup = group.data;
            }
            this.applyFilter();
            this.selectedFilter = null;

        },
        applyFilter() {
            if (!this.filterDisplayLabel) return;
            let filter = null;
            if (this.selectedFilter.type == "select") {
                filter = {
                    label: this.filterDisplayLabel,
                    type: this.selectedFilter.type,
                    filter: this.selectedFilter,
                    value: this.selectedFilterOption.value
                };
            } else if (this.selectedFilter.type == "date") {
                filter = {
                    label: this.filterDisplayLabel,
                    type: this.selectedFilter.type,
                    filter: this.selectedFilter,
                    value: this.selectedDate
                };
            } else if (this.selectedFilter.type == "contact") {
                filter = {
                    label: this.filterDisplayLabel,
                    type: this.selectedFilter.type,
                    filter: this.selectedFilter,
                    value: this.contactOptions.map(c => c.value)
                };
            } else if (this.selectedFilter.type == "list") {
                filter = {
                    label: this.filterDisplayLabel,
                    type: this.selectedFilter.type,
                    filter: this.selectedFilter,
                    value: this.selectedGroup.id
                };
            }

            if (!filter) return;
            filter.multiple = this.selectedFilter.multiple;

            
            //we need to check to see if selected filter supports multiple, and if not, if it exists, we replace it instead
            let existingIndex = this.activeFilters.findIndex(f => f.filter.value == this.selectedFilter.value);

            if (this.editing && this.editingIndex !== null) {
                this.activeFilters.splice(this.editingIndex, 1, filter);
                this.editing = false;
                this.editingIndex = null;
            } else if (this.selectedFilter.multiple || existingIndex == -1) {
                this.activeFilters.push(filter);
            } else {
                this.activeFilters.splice(existingIndex, 1, filter);
            }

            this.filterOpen = false;
        },
    },
    watch: {
        selectedFilter: function() {
            if (!this.editing) {
                this.selectedFilterOption = null;
            }
        },
        filterOpen(val) {
            if (!val) {
                this.selectedFilter = null;
                this.selectedFilterOption = null;
            }
        }
    },
}
</script>

<style scoped>
/* Styles for multiselect to match your design */

:deep(.multiselect) {
    width: auto;
}

:deep(.multiselect__tags) {
  min-height: 40px;
  padding: 0.5rem;
  border-radius: 0.375rem;
  border-color: #e2e8f0;
  width: 250px;
}

:deep(.multiselect__input) {
  font-size: 0.875rem;
}

:deep(.multiselect__content-wrapper) {
  border-radius: 0 0 0.375rem 0.375rem;
  border-color: #e2e8f0;
}

:deep(.multiselect__option--highlight) {
  background: #6366f1;
  color: white;
}

:deep(.multiselect__option--selected.multiselect__option--highlight) {
  background: #4f46e5;
  color: white;
}
</style>